import { ChangeColor } from './ChangeColor';

export class ChangeLogoUrl extends ChangeColor {
  type: string = 'ChangeLogoUrl';
}
